<template>
  <form-wrap
    class="new-comment__form"
    @submit="handleSubmitComment"
  >
    <form-field-set :should-show-border="false">
      <text-area-input
        v-model="newCommentBody"
        :placeholder="$t('p.contentPage.form.placeholder.writeComment')"
        direction="vertical"
        label=""
        name="new-comment"
      />
    </form-field-set>
    <button-input
      :is-disabled="newCommentBody.length <= 0"
      type="submit"
    >
      <font-awesome-icon icon="arrow-alt-circle-right" />
      <span v-t="'p.contentPage.form.action.submitComment'" />
    </button-input>
  </form-wrap>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon
  },
  computed: {
    ...mapState ({
      content: state => state.content.content
    }),
    newCommentBody: {
      get () { return this.$store.state.contentCommentForm.newCommentBody },
      set (value) { this.$store.dispatch('setNewCommentBody', value) }
    }
  },
  methods: {
    ...mapActions ([
      'createContentComment',
      'fetchContentComments'
    ]),
    handleSubmitComment () {
      this.createContentComment(this.content.id)
        .then(() => {
          this.fetchContentComments(this.content.id)
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/comments/CommentForm.vue